import type { ReactNode } from 'react';

export const symbol_game_button_r: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M416-347q7-7 7-18v-84h43l57 98q3.47 5 8.23 8 4.77 3 11.77 3 14 0 21.5-12.5T564-377l-53-87q26-11 39-29t13-44.26q0-40.74-26.22-62.24T460-621h-57q-12.75 0-21.37 8.62Q373-603.75 373-591v227q0 11 7 17.5t18 6.5q11 0 18-7Zm7-146v-83h35q26 0 40 11.1 14 11.11 14 30.54 0 20.36-15.21 30.86T453-493h-30ZM80-220v-426q0-63.53 44.5-108.76Q169-800 233-800h494q64 0 108.5 45.24Q880-709.53 880-646v426q0 24.75-17.62 42.37Q844.75-160 820-160H140q-24.75 0-42.37-17.63Q80-195.25 80-220Zm60 0h680v-426q0-38.78-27-66.39T727-740H233q-39 0-66 27.61T140-646v426Zm0 0h680-680Z"
		/>
	</svg>
);
